<div class="vars">
  <h3 class="vars-title">Meta Carousel Ad — variables</h3>
  <table class="vars-table">
    <thead>
      <tr>
        <th>Variable</th>
        <th>Value</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; trackBy: trackByName">
        <td class="vars-name">{{ row.name }}</td>
        <td class="vars-value" [class.empty]="!row.value">
          {{ row.value || '—' }}
          <img *ngIf="row.imageUrl as imageUrl" class="vars-image" [src]="imageUrl" alt="Card image" />
          <ng-container *ngIf="row.videoUrl as videoUrl">
            <video
              *ngIf="!failedVideos.has(videoUrl)"
              class="vars-image"
              [src]="videoUrl"
              muted
              controls
              preload="metadata"
              (error)="onVideoError(videoUrl)"
            ></video>
            <img
              *ngIf="failedVideos.has(videoUrl)"
              class="vars-image"
              [src]="videoUrl"
              alt="Card video"
            />
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>
